import classes from './ServiceCard.module.css';

const ServiceCard = ({ 
  handleClose,
  service, 
  selectPackage, 
  creativeId, 
  isSelected, 
  onOpenPackage, 
  onChangePackage,
  onRemovePackage,
  fromAddPackage = false
}) => {

  const handleSelectPackage = () => {
    if (selectPackage && creativeId) {
      selectPackage(service, creativeId);
    }
    if (handleClose) {
      handleClose();
    }
  };

  const handleOpenPackage = () => {
    if (onOpenPackage) {
      onOpenPackage(service);
    }
  };

  const handleChangePackage = () => {
    if (onChangePackage) {
      onChangePackage(service);
    }
  };

  const handleRemovePackage = (e) => {
    e.stopPropagation();
    if (onRemovePackage && service?.id) {
      onRemovePackage(service.id);
    }
  };

  return (
    <div className={classes.serviceCard}>
        {onRemovePackage && (
          <button 
            className={classes.removeButton}
            onClick={handleRemovePackage}
            aria-label="Paket entfernen"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M7.50947 8.5L0 0.990535L0.990535 0L8.5 7.50947L16.0095 0L17 0.990535L9.49054 8.5L17 16.0095L16.0095 17L8.5 9.49054L0.990535 17L0 16.0095L7.50947 8.5Z" fill="var(--black)"/>
            </svg>
          </button>
        )}
        {fromAddPackage ? (
            <div className={classes.serviceImageFromAddPackageContainer}>
                <div className={classes.serviceImageFromAddPackage}>
                    <img src={service?.processedPortfolioImages?.[0] || service?.portfolioImages?.[0]} alt={service?.name || service?.title} />
                </div>
                <span className='semiboldSmall'>{service?.name}</span>
            </div>
        ) : (
            <div className={classes.serviceImage}>
                <img src={service?.processedPortfolioImages?.[0] || service?.portfolioImages?.[0]} alt={service?.name || service?.title} />
            </div>
        )}
        <div className={classes.serviceInfosContainer}>
            <div className={classes.titleContainer}>
                {!fromAddPackage && (
                    <h2 className='semiboldSmall'>{service?.name}</h2>
                )}
                <span className='regularSmall'>{service?.price}€ pro Stunde</span>
                <p style={{color: 'var(--dark-grey-4)'}} className={`slimRegularMiniText ${classes.description}`}>
                    {service?.description}
                </p>
            </div>
            <div className={classes.deliverablesContainer}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                    <g clipPath="url(#clip0_16337_6866)">
                    <path d="M3.23047 7.40414L5.03474 5.55264C5.252 5.32593 5.54484 5.20312 5.83768 5.20312H8.60549C8.79442 5.20312 8.98334 5.25036 9.14393 5.34482L10.5609 6.15721C10.7309 6.25168 10.9104 6.29891 11.0993 6.29891H14.1222C14.7835 6.29891 15.3219 6.90348 15.3219 7.6592C15.3219 8.41491 14.7835 9.01948 14.1222 9.01948H9.17227" stroke="#CB1541" strokeWidth="1.13357" strokeMiterlimit="10"/>
                    <path d="M15.4155 7.36326L17.3425 6.00297C17.522 5.89906 17.6732 5.74792 17.7771 5.54954L18.6367 3.78306C18.7784 3.50911 19.0146 3.31074 19.298 3.23517L20.0442 3.02735C20.3087 2.95178 20.5827 2.99901 20.8188 3.1596C21.3573 3.50911 21.5084 4.31206 21.14 4.87885L17.9755 9.84767C17.9093 9.94213 17.8338 10.0272 17.7487 10.1027L15.7272 11.8125C15.5572 11.9637 15.3399 12.0392 15.1226 12.0487L7.48047 12.2943" stroke="#CB1541" strokeWidth="1.13357" strokeMiterlimit="10"/>
                    <path d="M3.23186 7.37868L7.40718 11.9791C7.71891 12.3286 7.69057 12.8671 7.3505 13.1788L5.98077 14.4257L0.671875 8.56893L2.04161 7.322C2.39113 7.01027 2.92013 7.02916 3.2413 7.37868H3.23186Z" stroke="#CB1541" strokeWidth="1.13357" strokeMiterlimit="10"/>
                    <path d="M7.26562 3.3688V0.8655C7.26562 0.648232 7.53957 0.46875 7.87964 0.46875H15.9374C16.2775 0.46875 16.5515 0.648232 16.5515 0.8655V3.3688" stroke="#CB1541" strokeWidth="1.13357" strokeMiterlimit="10"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_16337_6866">
                    <rect width="21.8118" height="15.0954" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>
                <ul className={classes.deliverablesList}>
                    {service?.includedServices?.map((item, index) => (
                        <li className='regularXs' key={index}>{item}</li>
                    ))}
                </ul>
            </div>
            <div className={classes.buttonsContainer}>
                <button 
                    onClick={handleOpenPackage}
                    className={`${classes.button} ${classes.buttonOpenPackage} mediumLarge`}
                >
                    Paket öffnen
                </button>
                {fromAddPackage ? (
                  <button 
                      onClick={handleChangePackage} 
                      className={`${classes.button} ${classes.buttonAddPackage} mediumLarge`}
                  >
                      Paket ändern
                  </button>
                ) : (
                  <button 
                      onClick={handleSelectPackage} 
                      className={`${classes.button} ${classes.buttonAddPackage} 
                      ${isSelected ? classes.buttonSelected : ''} mediumLarge`}
                  >
                      {isSelected ? 'Aktuelles Paket' : 'Hinzufügen'}
                  </button>
                )}
            </div>
        </div>
    </div>
  );
};

export default ServiceCard;


